import { render, staticRenderFns } from "./VehiculeAddPage.vue?vue&type=template&id=58335c2a&"
import script from "./VehiculeAddPage.vue?vue&type=script&lang=js&"
export * from "./VehiculeAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports